export default {"src":"/_next/static/media/mission_about.d7e1bbef.svg","height":2500,"width":3415,"blurWidth":0,"blurHeight":0};